export default function configs(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT_CONFIG':
            return {
                ...state,
                config: action.config,
            }
        default:
            return state;
    }
}
